import { useState, useEffect, useCallback } from 'react';

import {
  generateMindMap,
  initialElements,
} from '../../components/MindMap/utils/initialElements';
import { getCourseMindMap } from '../../api';
import { useFetch } from '../../hooks';
import mindMap from '../../components/MindMap/components/mindMap.json';

export const useMindMap = (id: string) => {
  const initialData = initialElements();
  const { loading, data } = useFetch(() => getCourseMindMap(id), [id]);
  const [modifiedMindMap, setModifiedMindMap] = useState<any>(initialData);

  // TODO(Kuriy): it's a temporary solution for the test purpose
  useEffect(() => {
    if (data && !loading) {
      setModifiedMindMap(generateMindMap(mindMap));
    }
  }, [data, loading]);

  const updateMindMap = useCallback((newData: any) => {
    if (!newData) return;

    setModifiedMindMap(generateMindMap(newData));
  }, []);

  return {
    id,
    loading,
    mindMap: modifiedMindMap,
    updateMindMap,
  };
};
